module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_1_0@2x.e28d19cc.png";